"use client";

import React from "react";
import Button from "../SecondaryButton";
import { useTrackUserEvent } from "@/utils/analytics";

export interface tabListType {
  id: number;
  label: string;
  disabled?: boolean;
  error?: boolean;
}

export interface TabsProps {
  tabList: tabListType[];
  defaultTab?: number;
  labelClassname?: string;
  selectedTab: number;
  onClick: (id: number) => void;
}

const StakingTab: React.FC<TabsProps> = ({
  tabList,
  labelClassname = "",
  selectedTab,
  onClick,
}) => {
  const trackUserEvent = useTrackUserEvent();

  const tabLabelClassname = (tab: tabListType) =>
    `min-w-[48px] font-jetbrans-mono font-medium text-base leading-4 ${
      tab.disabled ? "pointer-events-none" : "pointer-events-auto"
    } ${labelClassname} relative`;

  const tabDisabledClassname = (isDisabled: boolean) =>
    `flex flex-col items-center justify-center w-[140px] ${
      isDisabled ? "cursor-not-allowed" : "cursor-pointer"
    }`;

  return (
    <div className="flex gap-6 bg-[#F7F8F70A] p-2 w-full duration-300 ease-in-out">
      {tabList?.map((tab) => (
        <div
          className={`hover:bg-white/10 ${tabDisabledClassname(
            tab.disabled || false
          )}`}
          onClick={() => {
            trackUserEvent("Tab " + tab.label + " Click");
            if (!tab.disabled) {
              onClick(tab.id);
            }
          }}
          key={tab.id}
        >
          {selectedTab === tab.id ? (
            <Button disableHover variant="light">
              {tab.label}
            </Button>
          ) : (
            <div className={`${tabLabelClassname(tab)}`} role="presentation">
              {tab.label}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StakingTab;
